// hooks/useEvents.js
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { conf } from '../../../confg';

/**
 * Custom hook for managing events and announcements
 */
export const useEvents = () => {
  const [eventModal, setEventModal] = useState(false);
  const [eventModalText, setEventModalText] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadEvents = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios({
        url: conf.server_url + 'events',
        method: 'GET',
      });

      setEventModal(true);
      setEventModalText(response.data.message);
    } catch (error) {
      setEventModal(false);
      console.error('Error loading events:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const closeEventModal = useCallback(() => {
    setEventModal(false);
    setEventModalText(null);
  }, []);

  useEffect(() => {
    loadEvents();
  }, [loadEvents]);

  return {
    eventModal,
    eventModalText,
    loading,
    loadEvents,
    closeEventModal,
  };
};
